import React from "react";
import GallerySlideshow from "./GallerySlideshow";
import "./GallerySlideshow.css";

function GallerySlideshowSettings({
  memorial,
  selectedPlan,
  textColor,
  onUpdate,
  showPreview = true,
}) {
  const config = memorial?.gallerySlideshow || {};
  const photos = memorial?.gallery?.photos || [];
  const canUseSlideshow = selectedPlan !== 0 && selectedPlan != null;
  const minPhotos = photos.length >= 2;

  const handleToggle = (field, value) => {
    onUpdate({
      gallerySlideshow: {
        ...config,
        enabled: config.enabled ?? false,
        intervalSeconds: config.intervalSeconds ?? 5,
        transition: config.transition ?? "kenburns",
        syncBackgroundMusic: config.syncBackgroundMusic ?? true,
        [field]: value,
      },
    });
  };

  if (!canUseSlideshow) {
    return (
      <div className="slideshow-settings">
        <h4 style={{ color: textColor }}>Memorial slideshow</h4>
        <p className="slideshow-upgrade-note" style={{ color: textColor }}>
          Upgrade to Standard or Premium to unlock an automatic photo slideshow on this memorial.
        </p>
      </div>
    );
  }

  return (
    <div className="slideshow-settings">
      <h4 style={{ color: textColor }}>Memorial slideshow</h4>
      <p style={{ color: textColor, fontSize: "0.9rem", marginBottom: 12 }}>
        Create an automatic slideshow from your uploaded photos on the memorial page.
      </p>

      <div className="slideshow-settings-row">
        <label style={{ color: textColor }}>
          <input
            type="checkbox"
            checked={config.enabled === true}
            disabled={!minPhotos}
            onChange={(e) => handleToggle("enabled", e.target.checked)}
          />
          Enable slideshow on memorial page
        </label>
      </div>

      {!minPhotos && (
        <p className="slideshow-upgrade-note" style={{ color: textColor }}>
          Upload at least 2 photos to enable the slideshow.
        </p>
      )}

      {config.enabled && minPhotos && (
        <>
          <div className="slideshow-settings-row">
            <label style={{ color: textColor }}>
              Seconds per photo: {config.intervalSeconds ?? 5}
              <input
                type="range"
                min={3}
                max={12}
                value={config.intervalSeconds ?? 5}
                onChange={(e) => handleToggle("intervalSeconds", Number(e.target.value))}
              />
            </label>
          </div>
          <div className="slideshow-settings-row">
            <label style={{ color: textColor }}>
              <input
                type="checkbox"
                checked={config.syncBackgroundMusic !== false}
                onChange={(e) => handleToggle("syncBackgroundMusic", e.target.checked)}
              />
              Loop slideshow with background music
            </label>
          </div>
        </>
      )}

      {showPreview && config.enabled && minPhotos && (
        <GallerySlideshow
          photos={photos}
          intervalSeconds={config.intervalSeconds ?? 5}
          textColor={textColor}
        />
      )}
    </div>
  );
}

export default GallerySlideshowSettings;
